module.exports = __webpack_public_path__ + "img/2024080214362916S5A.3efb6a3f.png";